import React from "react";
import "../GetQuote.css";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import { NavLink } from "react-router-dom";

import {
    FiHome,
    FiChevronRight,
    FiFileText
} from "react-icons/fi";

const GetQuote = () => {

    return (

        <>

            <Header />

            {/* =====================================================
                            HERO SECTION
            ===================================================== */}

            <section className="quote-hero">

                <div className="quote-overlay"></div>

                <div className="container">

                    <div className="quote-hero-content">

                        <span className="quote-tag">
                            Free Project Estimation
                        </span>

                        <h1>

                            Get a
                            <span> Free Quote </span>
                            for Your Next Digital Project

                        </h1>

                        <p>

                            Ready to transform your business with technology?
                            Whether you need an e-commerce platform, business
                            website, mobile application, ERP system, or custom
                            software solution, our experts will provide a
                            customized quotation based on your business goals,
                            project scope, timeline, and budget.

                        </p>

                        <div className="quote-hero-buttons">

                            <a
                                href="#quote-form"
                                className="primary-btn"
                            >
                                Request Quote
                            </a>

                            <NavLink
                                to="/contact"
                                className="secondary-btn"
                            >
                                Contact Team
                            </NavLink>

                        </div>

                    </div>

                </div>

            </section>

            {/* =====================================================
                            BREADCRUMB
            ===================================================== */}

            <section className="quote-breadcrumb">

                <div className="container">

                    <div className="breadcrumb">

                        <NavLink to="/">
                            <FiHome />
                            Home
                        </NavLink>

                        <FiChevronRight />

                        <span className="active">

                            <FiFileText />

                            Get Quote

                        </span>

                    </div>

                </div>

            </section>

            {/* =====================================================
                        NEXT PART STARTS HERE

                    Quote Form

            ===================================================== */}
            {/* =====================================================
                            QUOTE FORM
            ===================================================== */}

            <section className="quote-section" id="quote-form">

                <div className="container">

                    <div className="quote-grid">

                        {/* ================= LEFT CONTENT ================= */}

                        <div className="quote-info">

                            <span className="section-tag">
                                Request a Quote
                            </span>

                            <h2>
                                Tell Us About Your Project
                            </h2>

                            <p>
                                Every business has unique requirements. Share
                                your project details with our team and we'll
                                prepare a customized proposal that aligns with
                                your objectives, budget, and expected timeline.
                            </p>

                            <div className="quote-feature">

                                <h3>✔ Free Consultation</h3>

                                <p>
                                    Discuss your project with our experienced
                                    consultants before making any commitment.
                                </p>

                            </div>

                            <div className="quote-feature">

                                <h3>✔ Transparent Pricing</h3>

                                <p>
                                    Receive a detailed quotation with a clear
                                    breakdown of scope, technology, timeline,
                                    and estimated cost.
                                </p>

                            </div>

                            <div className="quote-feature">

                                <h3>✔ Tailored Solutions</h3>

                                <p>
                                    Every proposal is customized to your
                                    business goals, industry, and future
                                    scalability requirements.
                                </p>

                            </div>

                            <div className="quote-feature">

                                <h3>✔ Quick Response</h3>

                                <p>
                                    Most quotation requests are reviewed within
                                    24–48 business hours by our technical team.
                                </p>

                            </div>

                        </div>

                        {/* ================= RIGHT FORM ================= */}

                        <div className="quote-form-wrapper">

                            <div className="quote-form">

                                <span className="section-tag">
                                    Project Details
                                </span>

                                <h2>
                                    Request Your Free Quote
                                </h2>

                                <form>

                                    {/* Row 1 */}

                                    <div className="form-row">

                                        <div className="form-group">

                                            <label>
                                                Full Name
                                            </label>

                                            <input
                                                type="text"
                                                placeholder="Enter your full name"
                                            />

                                        </div>

                                        <div className="form-group">

                                            <label>
                                                Company Name
                                            </label>

                                            <input
                                                type="text"
                                                placeholder="Your company name"
                                            />

                                        </div>

                                    </div>

                                    {/* Row 2 */}

                                    <div className="form-row">

                                        <div className="form-group">

                                            <label>
                                                Email Address
                                            </label>

                                            <input
                                                type="email"
                                                placeholder="Enter your email"
                                            />

                                        </div>

                                        <div className="form-group">

                                            <label>
                                                Phone Number
                                            </label>

                                            <input
                                                type="text"
                                                placeholder="Enter phone number"
                                            />

                                        </div>

                                    </div>

                                    {/* Row 3 */}

                                    <div className="form-row">

                                        <div className="form-group">

                                            <label>
                                                Select Service
                                            </label>

                                            <select>

                                                <option>
                                                    Choose a Service
                                                </option>

                                                <option>
                                                    E-Commerce Development
                                                </option>



                                                <option>
                                                    ERP / CRM Development
                                                </option>

                                                <option>
                                                    Custom Software
                                                </option>



                                                <option>
                                                    Digital Marketing
                                                </option>

                                                <option>
                                                    Cloud Solutions
                                                </option>

                                                <option>
                                                    Other Service
                                                </option>

                                            </select>

                                        </div>

                                        <div className="form-group">

                                            <label>
                                                Industry
                                            </label>

                                            <select>

                                                <option>
                                                    Select Industry
                                                </option>

                                                <option>
                                                    Retail
                                                </option>

                                                <option>
                                                    Agriculture
                                                </option>

                                                <option>
                                                    Healthcare
                                                </option>

                                                <option>
                                                    Manufacturing
                                                </option>

                                                <option>
                                                    Education
                                                </option>

                                                <option>
                                                    Logistics
                                                </option>

                                                <option>
                                                    Other
                                                </option>

                                            </select>

                                        </div>

                                    </div>

                                    {/* Row 4 */}

                                    <div className="form-row">

                                        <div className="form-group">

                                            <label>
                                                Budget Range
                                            </label>

                                            <select>

                                                <option>
                                                    Select Budget
                                                </option>

                                                <option>
                                                    Below ₹50,000
                                                </option>

                                                <option>
                                                    ₹50,000 – ₹2,00,000
                                                </option>

                                                <option>
                                                    ₹2,00,000 – ₹5,00,000
                                                </option>

                                                <option>
                                                    Not Discolse
                                                </option>



                                            </select>

                                        </div>

                                        <div className="form-group">

                                            <label>
                                                Expected Timeline
                                            </label>

                                            <select>

                                                <option>
                                                    Select Timeline
                                                </option>

                                                <option>
                                                    Within 2 Weeks
                                                </option>

                                                <option>
                                                    1 Month
                                                </option>

                                                <option>
                                                    2–3 Months
                                                </option>

                                                <option>
                                                    Flexible
                                                </option>

                                            </select>

                                        </div>

                                    </div>

                                    {/* Description */}

                                    <div className="form-group">

                                        <label>
                                            Project Description
                                        </label>

                                        <textarea
                                            rows="6"
                                            placeholder="Describe your project requirements..."
                                        ></textarea>

                                    </div>

                                    {/* Upload */}

                                    <div className="form-group">

                                        <label>
                                            Upload Requirement Document (Optional)
                                        </label>

                                        <input
                                            type="file"
                                        />

                                    </div>

                                    <button
                                        type="submit"
                                        className="submit-btn"
                                    >
                                        Request Free Quote
                                    </button>

                                </form>

                            </div>

                        </div>

                    </div>

                </div>

            </section>

            {/* =====================================================
                        NEXT PART STARTS HERE

                        Why Choose Us
                        +
                        Our Process
                        +
                        Services
                        +
                        Footer

            ===================================================== */}

            {/* =====================================================
                        WHY REQUEST A QUOTE
            ===================================================== */}

            <section className="why-quote">

                <div className="container">

                    <div className="section-heading">

                        <span className="section-tag">
                            Why Request a Quote?
                        </span>

                        <h2>
                            A Better Way to Start Your
                            <span> Digital Journey</span>
                        </h2>

                        <p>
                            Our quotation process is simple, transparent, and
                            tailored to your business needs. We focus on
                            understanding your goals before recommending the
                            right technology solution.
                        </p>

                    </div>

                    <div className="why-quote-grid">

                        <div className="why-quote-card">

                            <h3>💰 Transparent Pricing</h3>

                            <p>
                                Receive a detailed quotation with a clear
                                breakdown of project scope, estimated cost,
                                and timelines. No hidden charges.
                            </p>

                        </div>

                        <div className="why-quote-card">

                            <h3>🎯 Customized Solutions</h3>

                            <p>
                                Every proposal is designed specifically for
                                your business, industry, operational needs,
                                and future scalability.
                            </p>

                        </div>

                        <div className="why-quote-card">

                            <h3>👨‍💻 Expert Consultation</h3>

                            <p>
                                Discuss your requirements with experienced
                                professionals who help identify the most
                                suitable technology stack.
                            </p>

                        </div>

                        <div className="why-quote-card">

                            <h3>⚡ Fast Turnaround</h3>

                            <p>
                                Most quotations are prepared and shared within
                                24–48 business hours after reviewing your
                                requirements.
                            </p>

                        </div>

                    </div>

                </div>

            </section>

            {/* =====================================================
                        OUR PROCESS
            ===================================================== */}

            <section className="quote-process">

                <div className="container">

                    <div className="section-heading">

                        <span className="section-tag">
                            Our Process
                        </span>

                        <h2>

                            How We Prepare
                            <span> Your Proposal</span>

                        </h2>

                    </div>

                    <div className="process-grid">

                        <div className="process-card">

                            <div className="process-number">
                                01
                            </div>

                            <h3>
                                Submit Requirement
                            </h3>

                            <p>
                                Fill in the quotation form with your project
                                details, goals, and expectations.
                            </p>

                        </div>

                        <div className="process-card">

                            <div className="process-number">
                                02
                            </div>

                            <h3>
                                Requirement Analysis
                            </h3>

                            <p>
                                Our technical experts carefully review your
                                requirements and identify the best solution.
                            </p>

                        </div>

                        <div className="process-card">

                            <div className="process-number">
                                03
                            </div>

                            <h3>
                                Proposal & Estimation
                            </h3>

                            <p>
                                We prepare a detailed proposal including
                                technology, timeline, deliverables, and cost.
                            </p>

                        </div>

                        <div className="process-card">

                            <div className="process-number">
                                04
                            </div>

                            <h3>
                                Project Kickoff
                            </h3>

                            <p>
                                Once approved, our development team begins
                                executing your project with regular updates.
                            </p>

                        </div>

                    </div>

                </div>

            </section>

            {/* =====================================================
                        POPULAR SERVICES
            ===================================================== */}

            <section className="quote-services">

                <div className="container">

                    <div className="section-heading">

                        <span className="section-tag">
                            Popular Services
                        </span>

                        <h2>

                            Frequently Requested
                            <span> Solutions</span>

                        </h2>

                        <p>
                            We deliver modern digital solutions that help
                            businesses grow, automate operations, and improve
                            customer experiences across multiple industries.
                        </p>

                    </div>

                    <div className="services-grid">

                        <div className="service-card">

                            <h3>
                                E-Commerce Development
                            </h3>

                            <p>
                                B2B, B2C, multi-vendor marketplaces, retail,
                                and agriculture commerce solutions.
                            </p>

                        </div>

                        <div className="service-card">

                            <h3>
                                Retail E-Commerce Solutions
                            </h3>

                            <p>
                                Develop modern omnichannel retail platforms with inventory management,
                                secure online payments, customer loyalty programs, and real-time order
                                tracking for a seamless shopping experience.
                            </p>

                        </div>

                        <div className="service-card">

                            <h3>
                                Agriculture E-Commerce Platforms
                            </h3>

                            <p>
                                Build digital marketplaces for farmers, agri-businesses, cooperatives,
                                and suppliers with product catalogs, bulk ordering, logistics, and
                                direct farm-to-customer selling capabilities.
                            </p>

                        </div>

                        <div className="service-card">

                            <h3>
                                Education & Learning Portals
                            </h3>

                            <p>
                                Create scalable education platforms featuring online course management,
                                student enrollment, digital content delivery, assessments, and secure
                                payment integration for educational institutions.
                            </p>

                        </div>
                        <div className="service-card">

                            <h3>
                                Manufacturing & B2B Commerce
                            </h3>

                            <p>
                                Empower manufacturers, distributors, and wholesalers with B2B e-commerce
                                platforms featuring dealer portals, bulk ordering, quotation management,
                                inventory synchronization, and supply chain integration.
                            </p>

                        </div>
                        <div className="service-card">

                            <h3>
                                Digital Marketing
                            </h3>

                            <p>
                                SEO, social media marketing, paid campaigns,
                                branding, and lead generation services.
                            </p>

                        </div>

                    </div>

                </div>

            </section>

            <Footer />

        </>

    );

};

export default GetQuote;